import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: process.env.VUE_APP_RENDER === 'prerender' ? 'history' : '',
  base: process.env.VUE_APP_PATH,
  routes: [
    {
      path: '/',
      redirect: '/landing'
    },
    {
      path: '/landing',
      alias: '/index.html',
      name: 'landing',
      component: () => import('@/views/Landing.vue'),
   
    },
    {
      path: '/:source',
      alias: '/',
      name: '',
      component: () => import('@/views/SourcePage.vue'),
   
    },

  ]
});